import { options, nextArrow, prevArrow } from "@/global/slick-options";

const accreditationsSlider = document.querySelectorAll('[data-slider="accreditations-slider"]');
if ( accreditationsSlider.length ) {
    accreditationsSlider.forEach( slider => {

        jQuery( slider ).slick( {
            ...options,
            arrows: false,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            pauseOnFocus: true,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        } );
    } );
}
